import React, { lazy, Suspense } from "react"
import { motion } from "framer-motion"
import { useMediaQuery } from "react-responsive"
import { Link } from "react-router-dom"
import { PROJECT_LIST } from "./SortContext"

// Lazy load the ResponsiveImage component
const ResponsiveImage = lazy(() => import("./ResponsiveImage"))

export default function ImageGrid({ containerWidth, containerHeight, selectedOption, selectedCategory }) {
    const images = React.useMemo(() => [
        {
            text: "SAGA Adaptive Apparel",
            subtitle: "(Bachelor's Capstone Project)",
            link: "/saga-adaptive-apparel",
            date: "2025-12-12",
            categories: ["apparel"],
            imageUrl: "/images/projects/Saga Adaptive Apparel/SAGA Cover Image.jpg",
            imageUrlWebp: "/images/projects/Saga Adaptive Apparel/SAGA Cover Image.webp",
            imageSizes: {
                small: "/images/projects/Saga Adaptive Apparel/SAGA Cover Image-small.webp",
                medium: "/images/projects/Saga Adaptive Apparel/SAGA Cover Image-medium.webp",
                large: "/images/projects/Saga Adaptive Apparel/SAGA Cover Image.webp",
            }
        },
        {
            text: "Under Armour Rookie Project \"Second Nature\"",
            link: "/under-armour-second-nature",
            date: "2025-08-06",
            categories: ["apparel"],
            imageUrl: "/images/projects/uarookiecover.jpg",
            imageUrlWebp: "/images/projects/uarookiecover.webp",
            imageSizes: {
                small: "/images/projects/uarookiecover-small.webp",
                medium: "/images/projects/uarookiecover-medium.webp",
                large: "/images/projects/uarookiecover.webp",
            }
        },
        {
            text: "Scandinavian Neck Gaiter",
            link: "/scandinavian-neck-gaiter",
            date: "2024-12-12",
            categories: ["accessories"],
            imageUrl: "/images/projects/scandinavian-neck-gaiter.jpg",
            imageUrlWebp: "/images/projects/scandinavian-neck-gaiter.webp",
            imageSizes: {
                small: "/images/projects/scandinavian-neck-gaiter-small.webp",
                medium: "/images/projects/scandinavian-neck-gaiter-medium.webp",
                large: "/images/projects/scandinavian-neck-gaiter.webp",
            }
        },
        {
            text: 'Nike "Attire for All"',
            link: "/nike-ata",
            date: "2024-10-13",
            categories: ["apparel", "footwear"],
            imageUrl: "/images/projects/nike-ata.jpg",
            imageUrlWebp: "/images/projects/nike-ata.webp",
            imageSizes: {
                small: "/images/projects/nike-ata-small.webp",
                medium: "/images/projects/nike-ata-medium.webp",
                large: "/images/projects/nike-ata.webp",
            }
        },
        {
            text: 'Levi Strauss & Co. "Respirate"',
            link: "/levi-respirate",
            date: "2023-10-13",
            categories: ["apparel"],
            imageUrl: "/images/projects/levi-respirate.jpg",
            imageUrlWebp: "/images/projects/levi-respirate.webp",
            imageSizes: {
                small: "/images/projects/levi-respirate-small.webp",
                medium: "/images/projects/levi-respirate-medium.webp",
                large: "/images/projects/levi-respirate.webp",
            }
        },
        {
            text: "Spyder x CSU",
            link: "/spydercsu",
            date: "2024-12-05",
            categories: ["apparel"],
            imageUrl: "/images/projects/Spyder-csu-embroidery.png",
            imageUrlWebp: "/images/projects/Spyder-csu-embroidery.webp",
            imageSizes: {
                small: "/images/projects/Spyder-csu-embroidery-small.webp",
                medium: "/images/projects/Spyder-csu-embroidery-medium.webp",
                large: "/images/projects/Spyder-csu-embroidery.webp",
            }
        },
        {
            text: "Budai Wallet",
            link: "/budai-wallet",
            date: "2025-03-04",
            categories: ["accessories"],
            imageUrl: "/images/projects/budaiwallet.jpg",
            imageUrlWebp: "/images/projects/budaiwallet.webp",
            imageSizes: {
                small: "/images/projects/budaiwallet-small.webp",
                medium: "/images/projects/budaiwallet-medium.webp",
                large: "/images/projects/budaiwallet.webp",
            }
        },
        {
            text: "Canoe Bag",
            link: "/canoe-bag",
            date: "2025-05-13",
            categories: ["accessories"],
            imageUrl: "/images/projects/canoe-bag.png",
            imageUrlWebp: "/images/projects/canoe-bag.webp",
            imageSizes: {
                small: "/images/projects/canoe-bag-small.webp",
                medium: "/images/projects/canoe-bag-medium.webp",
                large: "/images/projects/canoe-bag.webp",
            }
        },
        {
            text: "Adaptive Study",
            link: "/adaptive-study",
            date: "2025-12-10",
            categories: ["apparel", "footwear"],
            imageUrl: "/images/projects/Adaptive Study/Adaptive Study Cover.png",
            imageUrlWebp: "/images/projects/Adaptive Study/Adaptive Study Cover.webp",
            imageSizes: {
                small: "/images/projects/Adaptive Study/Adaptive Study Cover-small.webp",
                medium: "/images/projects/Adaptive Study/Adaptive Study Cover-medium.webp",
                large: "/images/projects/Adaptive Study/Adaptive Study Cover-large.webp",
            }
        },
        {
            text: "Senior Footwear Design Prototype",
            link: "/senior-footwear-design-prototype",
            date: "2025-12-05",
            categories: ["footwear"],
            imageUrl: "/images/projects/Footwear Design/Footwear Design Cover.png",
            imageUrlWebp: "/images/projects/Footwear Design/Footwear Design Cover.webp",
            imageSizes: {
                small: "/images/projects/Footwear Design/Footwear Design Cover-small.webp",
                medium: "/images/projects/Footwear Design/Footwear Design Cover-medium.webp",
                large: "/images/projects/Footwear Design/Footwear Design Cover.webp",
            }
        },
        {
            text: "ALO Apparel Brief",
            link: "/alo-apparel-brief",
            date: "2026-03-09",
            categories: ["apparel"],
            imageUrl: "/images/projects/alo design packet/cover image.jpg",
            imageUrlWebp: "/images/projects/alo design packet/cover image.webp",
            imageSizes: {
                small: "/images/projects/alo design packet/cover image-small.webp",
                medium: "/images/projects/alo design packet/cover image-medium.webp",
                large: "/images/projects/alo design packet/cover image-large.webp",
            }
        },
    ], []);

    const formatDate = (dateString) => {
        const date = new Date(dateString + "T00:00:00")
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        const year = String(date.getFullYear()).slice(-2)
        return `${month}/${day}/${year}`
    }

    // Pre-sort and filter images based on date and category
    const sortedImages = React.useMemo(() => {
        const filtered = selectedCategory
            ? images.filter((img) => img.categories && img.categories.includes(selectedCategory))
            : images
        return [...filtered].sort((a, b) => {
            if (selectedOption === "") {
                const orderA = PROJECT_LIST.find(p => p.path === a.link)?.order ?? 999
                const orderB = PROJECT_LIST.find(p => p.path === b.link)?.order ?? 999
                return orderA - orderB
            } else if (selectedOption === "newToOld") {
                return new Date(b.date) - new Date(a.date)
            } else if (selectedOption === "oldToNew") {
                return new Date(a.date) - new Date(b.date)
            }
            const orderA = PROJECT_LIST.find(p => p.path === a.link)?.order ?? 999
            const orderB = PROJECT_LIST.find(p => p.path === b.link)?.order ?? 999
            return orderA - orderB
        })
    }, [images, selectedOption, selectedCategory])

    const isMobile = useMediaQuery({ maxWidth: 767 })
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 })
    const isLandscapePhone = useMediaQuery({ minWidth: 568, maxWidth: 896, orientation: 'landscape' })
    const isLandscapeTablet = useMediaQuery({ minWidth: 897, maxWidth: 1366, orientation: 'landscape' })

    const responsiveStyles = React.useMemo(() => {
        // Landscape phone: 2 tiles at ~250px each
        if (isLandscapePhone) {
            return {
                boxSize: "250px",
                rowGap: "20px",
                columnGap: "30px",
                imageSizes: "250px",
            }
        }
        // Landscape tablet: 2 tiles at ~400px each
        if (isLandscapeTablet) {
            return {
                boxSize: "400px",
                rowGap: "30px",
                columnGap: "50px",
                imageSizes: "400px",
            }
        }
        // Default portrait/desktop behavior
        return {
            boxSize: isMobile ? "300px" : isTablet ? "350px" : "500px",
            rowGap: isMobile ? "20px" : isTablet ? "20px" : "50px",
            columnGap: isMobile ? "0px" : isTablet ? "50px" : "100px",
            imageSizes: isMobile ? "300px" : isTablet ? "350px" : "500px",
        }
    }, [isMobile, isTablet, isLandscapePhone, isLandscapeTablet])

    // Memoize the image style object to prevent re-renders
    const imageStyle = React.useMemo(() => ({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block"
    }), []);

    return (
        <div
            style={{
                width: containerWidth || "100%",
                height: containerHeight || "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    rowGap: responsiveStyles.rowGap,
                    columnGap: responsiveStyles.columnGap,
                    width: "100%",
                    justifyContent: (isMobile && !isLandscapePhone) ? "center" : "space-evenly",
                    padding: "20px",
                    boxSizing: "border-box",
                }}
            >
                {sortedImages.map((image, index) => (
                    <Link
                        key={index}
                        to={image.link}
                        style={{ 
                            textDecoration: "none", 
                            color: "inherit",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: isMobile ? "100%" : "auto"
                        }}
                    >
                        <motion.div
                            style={{
                                position: "relative",
                                overflow: "hidden",
                                borderRadius: "4px",
                                width: responsiveStyles.boxSize,
                                height: responsiveStyles.boxSize,
                                alignSelf: "center"
                            }}
                            whileHover={!isMobile && !isTablet ? { scale: 1.05 } : {}}
                        >
                            <Suspense fallback={
                                <div style={{
                                    width: "100%",
                                    height: "100%",
                                    background: "#f0f0f0"
                                }}/>
                            }>
                                <ResponsiveImage 
                                    src={image.imageUrl}
                                    alt={image.text}
                                    style={imageStyle}
                                    loading={index < 2 ? "eager" : "lazy"}
                                    priority={index === 0}
                                    sizes={responsiveStyles.imageSizes}
                                />
                            </Suspense>
                            {!isMobile && !isTablet && (
                                <motion.div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        opacity: 0,
                                    }}
                                    whileHover={{ opacity: 1 }}
                                >
                                    <p
                                        style={{
                                            fontSize: "1.2rem",
                                            textAlign: "center",
                                            fontFamily: "Fanwood, serif",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {image.text}
                                        {image.subtitle && (
                                            <>
                                                <br />
                                                <span style={{ fontWeight: "900" }}>{image.subtitle}</span>
                                            </>
                                        )}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "0.9rem",
                                            textAlign: "center",
                                            position: "absolute",
                                            bottom: "10px",
                                            left: "10px",
                                        }}
                                    >
                                        {formatDate(image.date)}
                                    </p>
                                </motion.div>
                            )}
                        </motion.div>
                        {(isMobile || isTablet) && (
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: "10px",
                                }}
                            >
                                <p style={{ 
                                    fontSize: "1.2rem",
                                    textAlign: "center",
                                    fontFamily: "Fanwood, serif",
                                    fontWeight: "bold"
                                }}>
                                    {image.text}
                                    {image.subtitle && (
                                        <>
                                            <br />
                                            <span style={{ fontWeight: "900" }}>{image.subtitle}</span>
                                        </>
                                    )}
                                </p>
                                <p style={{ fontSize: "0.9rem" }}>
                                    {formatDate(image.date)}
                                </p>
                            </div>
                        )}
                    </Link>
                ))}
            </div>
        </div>
    )
}